import { render, staticRenderFns } from "./ReportUserModal.vue?vue&type=template&id=ec15a9bc&"
import script from "./ReportUserModal.vue?vue&type=script&lang=js&"
export * from "./ReportUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports